import MonarchSiteDemoScreen from "../../../src/features/arrangements/screens/MonarchSiteDemoScreen";

export default function LegacyMonarchRoute() {
  return <MonarchSiteDemoScreen />;
}
